import { Control, FieldPathByValue, FieldValues, useController } from 'react-hook-form';

import { InfoCircle } from '../../assets/icons/index';
import { getPlainTextFromHtml } from '../../utils/get-plain-text-from-html.util';
import { TextEditor } from './text-editor';

export type FormTextEditorProps<
  TFieldValues extends FieldValues,
  TPath extends FieldPathByValue<TFieldValues, unknown>,
> = {
  control: Control<TFieldValues>;
  label?: string;
  maxLength?: number;
  name: TPath;
  placeholder?: string;
};

export const FormTextEditor = <
  TFieldValues extends FieldValues,
  TPath extends FieldPathByValue<TFieldValues, unknown>,
>({
  control,
  name,
  placeholder,
  ...props
}: FormTextEditorProps<TFieldValues, TPath>) => {
  const { field, fieldState } = useController({ control, name });

  const errorMessage = fieldState.error?.message ?? fieldState.error?.type;
  return (
    <div className="flex flex-col gap-3">
      <TextEditor
        {...props}
        {...field}
        onChange={(html: string) => {
          const plain = getPlainTextFromHtml(html);

          field.onChange(plain.length === 0 ? '' : html);
        }}
        placeholder={placeholder}
      />
      {errorMessage && (
        <div className="flex items-center gap-1">
          <InfoCircle />
          <div className="whitespace-pre-line text-left font-inter text-xs font-[450] text-fireside-600">
            {errorMessage}
          </div>
        </div>
      )}
    </div>
  );
};
